import React from "react";
import {CodPastPeriodsPage} from "../CodPastPeriodsPage";

export const BackOfficeCODPastPeriodsPage = () => {
    return <CodPastPeriodsPage isFromCustomerTheme={false} />;
};
